export const FETCH_AGGREGATIONS = 'catalog-menu/fetch-aggregations';
export const RECEIVE_AGGREGATIONS = 'catalog-menu/receive-aggregations';
